export default __webpack_public_path__ + "static/media/schoolDate3.137f02eb.png";